import { gql } from '@apollo/client'
import { useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { integrationsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useProjectId } from '@btime/react-session'

const Context = React.createContext()
const { Provider } = Context
export const useIntegrationsState = () => React.useContext(Context) || {}
export const useIntegrations = () => useIntegrationsState()?.integrations || []

const QUERY = gql`
  query Integrations($page: Int, $search: String, $sort: IntegrationSort, $filter: IntegrationFilter) {
    integrations(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      service
      insertedAt
      updatedAt
    }
  }
`

const IntegrationsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const currentProjectId = useProjectId()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'SERVICE', type },
      filter: { projectId: currentProjectId }
    },
    client: integrationsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default IntegrationsLoader
